import { classNames } from "primereact/utils"
import InputFrame from "./InputFrame"
import { AutoComplete } from 'primereact/autocomplete'
import { confirmDialog } from "primereact/confirmdialog"

export default function InputAutoCompleteMultipleForm(props) {

    const field = props.controller.field
    const fieldState = props.controller.fieldState

    const selecionados = props.selecionados
    const setSelecionados = props.setSelecionados

    const handleChange = (e) => {
        const novoValor = e.value

        if (novoValor.length < selecionados.length) {
            const removido = selecionados.find((s) => !novoValor.includes(s))

            confirmDialog({
                message: `Remover o endereço ${props.valueFormatado(removido)}?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (!props.beforeDelete || props.beforeDelete(e, removido)) {
                        setSelecionados(novoValor)
                    }
                },
            })
        } else {
            const inserido = novoValor.find((item) => !selecionados.includes(item))

            if (!props.beforeInsert || props.beforeInsert(e, inserido)) {
                setSelecionados(novoValor)
            }
        }
    }

    return (
        <>
            <InputFrame {...props}>
                <AutoComplete
                    id={field.name}
                    multiple
                    inputId={field.name}
                    className={'p-inputtext-sm ' + (fieldState.isDirty ? 'bg-green-100' : '') + classNames({ 'p-invalid': fieldState.error })}
                    size='small'
                    field={field.name}
                    value={props.selecionados}
                    suggestions={props.suggestions}
                    completeMethod={props.completeMethod}
                    onChange={handleChange}

                    itemTemplate={(item) => <span>{props.valueFormatado(item)}</span>}
                    selectedItemTemplate={(item) => <span>{props.valueFormatado(item)}</span>}

                    forceSelection={props.forceSelection || true}
                    autoComplete={props.autoComplete || "new-password"}
                    placeholder={props.placeholder || ''}
                />
            </InputFrame>
        </>
    )
}

// Exemplo

{/* <ControllerInput
    addClassName="md:col-12 lg:col-8 xl:col-6"
    field="produto_endereco"
    form={form}
    service={service}
    type="autocompletemultiple"
    label="Endereços (M)"

    selecionados={enderecoSelecionados}
    setSelecionados={setEnderecoSelecionados}
    suggestions={enderecos}
    completeMethod={loadEnderecos}
    valueFormatado={enderecoFormatado}
    placeholder='Pesquisar'
    beforeInsert={(e, inserted) => {
        const novo = {
            codigo_proe: null,
            cod_prod_proe: form.getValues('codigo_prod'),
            cod_endp_proe: inserted.codigo_endp,
            principal_proe: 0,
            dh_atua_proe: null,
            endereco_produto: {},
            meta: {}
        }
        produtoEndereco.append(novo)
        return true
    }}
    beforeDelete={(e, removed) => {
        const index = form.getValues('produto_endereco')
            .findIndex(p => p.cod_endp_proe === removed.codigo_endp)
        if (index >= 0) {
            produtoEndereco.remove(index)
        }
        return true
    }}
/> */}